<template>
  <div class="page-container">
    <el-card>
      <!-- 搜索区 -->
      <div class="search-bar">
        <el-input
          v-model="query.keywords"
          placeholder="订单号 / 用户名 / 联系方式"
          clearable
          style="width:220px"
          @keyup.enter.native="handleSearch"
        />
        <el-select v-model="query.status" placeholder="订单状态" clearable style="width:130px">
          <el-option label="待付款" :value="0" />
          <el-option label="已付款" :value="1" />
          <el-option label="部分退款" :value="2" />
          <el-option label="已取消" :value="3" />
          <el-option label="已退款" :value="4" />
          <el-option label="已完成" :value="5" />
        </el-select>
        <el-select v-model="query.refund_apply_status" placeholder="退款申请" clearable style="width:120px">
          <el-option label="未申请" :value="0" />
          <el-option label="已申请" :value="1" />
        </el-select>
        <el-button type="primary" size="mini" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button size="mini" icon="el-icon-refresh" @click="handleReset">重置</el-button>
      </div>

      <!-- 表格 -->
      <el-table :data="tableData" v-loading="loading" border stripe style="width:100%">
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column prop="order_no" label="商品订单号" min-width="190" show-overflow-tooltip />
        <el-table-column label="订单状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="statusType(row.status)" size="small">
              {{ row.status_label || statusLabel(row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="buyer_name" label="客户姓名" width="100" />
        <el-table-column prop="buyer_phone" label="手机号" width="130" />
        <el-table-column prop="created_at" label="下单时间" width="160" />
        <el-table-column prop="product_name" label="商品名称" min-width="150" show-overflow-tooltip />
        <el-table-column prop="quantity" label="数量" width="60" align="center" />
        <el-table-column label="实付金额" width="110" align="right">
          <template slot-scope="{ row }">
            <span class="val-price">¥{{ toFixed2(row.pay_amount) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="90" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              v-permission="['order:product:detail']"
              type="primary" size="mini" icon="el-icon-view"
              @click="$router.push(`/order/product/detail?id=${row.id}`)"
            >详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        :current-page="query.page"
        :page-sizes="[10, 15, 20, 50]"
        :page-size="query.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top:16px;text-align:right"
        @size-change="val => { query.pageSize = val; fetchData() }"
        @current-change="val => { query.page = val; fetchData() }"
      />
    </el-card>
  </div>
</template>

<script>
import { getProductOrderList } from '@/api/order'

const ORDER_STATUS = {
  0: { label: '待付款', type: 'warning' },
  1: { label: '已付款', type: 'success' },
  2: { label: '部分退款', type: '' },
  3: { label: '已取消', type: 'info' },
  4: { label: '已退款', type: 'danger' },
  5: { label: '已完成', type: 'success' }
}

export default {
  name: 'ProductOrderList',
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      query: { page: 1, pageSize: 15, keywords: '', status: '', refund_apply_status: '' }
    }
  },
  watch: {
    // 统一处理 created（首次）和 activated（keep-alive 激活）两种进入场景。
    // 当路由携带 refund_apply_status 参数时（如从首页统计卡片跳入），自动应用筛选条件。
    $route: {
      immediate: true,
      handler(to) {
        if (to.path !== '/order/product') return
        const refundStatus = to.query.refund_apply_status
        this.query.refund_apply_status = refundStatus !== undefined ? Number(refundStatus) : ''
        this.query.page = 1
        this.fetchData()
      }
    }
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const params = { ...this.query }
        if (params.status === '') delete params.status
        if (params.refund_apply_status === '') delete params.refund_apply_status
        if (!params.keywords) delete params.keywords
        const res = await getProductOrderList(params)
        const d = res.data || {}
        this.tableData = d.list || []
        this.total = d.total || 0
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.query.page = 1; this.fetchData() },
    handleReset() {
      this.query = { page: 1, pageSize: 15, keywords: '', status: '', refund_apply_status: '' }
      this.fetchData()
    },
    statusType(s) { return (ORDER_STATUS[s] || {}).type || '' },
    statusLabel(s) { return (ORDER_STATUS[s] || {}).label || String(s) },
    toFixed2(val) { return Number(val || 0).toFixed(2) }
  }
}
</script>

<style lang="scss" scoped>
.search-bar { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; flex-wrap: wrap; }
.val-price   { color: #f56c6c; font-weight: 600; }
</style>
